import { render } from "./DialogBookTransferAlert.vue?vue&type=template&id=5b960068&scoped=true"
import script from "./DialogBookTransferAlert.vue?vue&type=script&lang=js"
export * from "./DialogBookTransferAlert.vue?vue&type=script&lang=js"

import "./DialogBookTransferAlert.vue?vue&type=style&index=0&id=5b960068&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b960068"

export default script